// extracted by mini-css-extract-plugin
export default {"button":"button_button__EfIkQ","loading":"button_loading__wyGVG"};